export default __webpack_public_path__ + "static/media/INFP-1.c00ea613.png";